import React, { useEffect, useState } from "react";
import Confetti from "react-confetti";
import "../../assets/css/RepublicDay.css";
import $ from "jquery";

function RepublicDayLoader() {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  const [visibleLetters, setVisibleLetters] = useState("");

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener("resize", handleResize);

    const republicMessages = [
      "Happy Republic Day 🇮🇳",
      "26 January – Jai Hind",
      "Proud to be Indian",
      "Unity in Diversity",
      "Satyameva Jayate",
    ];

    const text =
      republicMessages[Math.floor(Math.random() * republicMessages.length)];

    let index = 0;

    const interval = setInterval(() => {
      if (index < text.length) {
        setVisibleLetters((prev) => prev + text[index]);
        index++;
      } else {
        clearInterval(interval);
      }
    }, 120);

    return () => {
      window.removeEventListener("resize", handleResize);
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    $("body").css("overflow", "hidden");
  }, []);

  function handleLoad() {
    setTimeout(function () {
      $("#loadingdiv").fadeOut();
      $("body").css("overflowY", "visible");
      $("#root").fadeIn();
    }, 3700);
  }

  return (
    <div
      id="loadingdiv"
      className="republic-loading-container"
      onLoad={handleLoad}
    >
      {/* Confetti in Flag Colors */}
      <Confetti
        width={windowSize.width}
        height={windowSize.height}
        colors={["#FF9933", "#FFFFFF", "#138808"]}
        numberOfPieces={220}
      />

      <div className="republic-content">
        <div className="chakra-ring">
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/1/17/Ashoka_Chakra.svg"
            alt="Ashoka Chakra"
          />
        </div>

        <h1 className="republic-text">{visibleLetters}</h1>

        <p className="republic-tagline">
          Justice • Liberty • Equality • Fraternity
        </p>
      </div>
    </div>
  );
}

export default RepublicDayLoader;
